import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { grey } from "@mui/material/colors";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useCheckout } from "components/StripeCheckout/useCheckout";
import { useSubscription } from "utils/useSubscription";

const styles = {
  strike: {
    textDecoration: "line-through",
    color: "#7a9f9c",
    fontSize: 22,
  },
  strikeMobile: {
    textDecoration: "line-through",
    fontSize: 20,
    color: "#FFBAAB",
  },
};

interface Props {
  plan: Plans;
}

const PlansPrice = ({ plan }: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { plans } = useContext(SubscriptionContext);
  const { getPromoCodeForPlan } = useCheckout();
  const { getPrice } = useSubscription();
  const promoCode = getPromoCodeForPlan(plan);

  if (!plans) return <></>;

  const originalPrice = Number(plans[plan]?.price);
  const discountedPrice = Number(getPrice(plan)) || originalPrice;
  const hasDiscounted = originalPrice > discountedPrice;

  if (isMobileScreen) {
    return (
      <Box sx={{ fontSize: hasDiscounted ? 20 : 24 }}>
        <Box component={"span"} sx={hasDiscounted ? styles.strikeMobile : {}}>
          ${originalPrice}
        </Box>

        {hasDiscounted && <Box component={"span"}> ${getPrice(plan)}</Box>}
        <Box component={"span"} sx={{ color: grey[400] }}>
          /mo
        </Box>
        {hasDiscounted && promoCode?.dateEnding && (
          <Typography sx={{ fontSize: 11, color: grey[400] }}>
            until {promoCode?.dateEnding} 💥
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <>
      <Box sx={hasDiscounted ? styles.strike : {}}>
        <Box>${originalPrice}/mo</Box>
      </Box>
      {hasDiscounted && <Box>${getPrice(plan)}/mo</Box>}
      {promoCode?.dateEnding && hasDiscounted && (
        <Typography sx={{ color: "#d95e58" }}>
          until {promoCode?.dateEnding}
        </Typography>
      )}
    </>
  );
};

export default PlansPrice;
